// src/components/layout/Footer.jsx
import React from 'react';
import '../../styles/globals.css';

const Footer = () => {
    return (
        <footer className="footer">
            <p>© 2024 NL Nature. All rights reserved. </p>
            <p>Created by Yuliia Ohol</p>
        </footer>
    );
};

export default Footer;

